import { Button, Spinner, TextInput } from "flowbite-react";
import { StyledReportPage } from "../_styles/StyledReportPage";
import { FC } from "react";
import { CondensedCodeDataGrid } from "../../components/CondensedCodeDataGrid";
import { CodeLabel } from "../../components/CodeLabel";
import { FormStateType } from "../../enums";
import { useVeloeRotasPage } from "./VeloeRotasPage.hook";
import { VeloeCalculoRotaModalPage } from "./VeloeCalculoRotaModalPage";

export const VeloeRotasPage: FC = () => {

    const {
        loading, columns, dataSource, handlePesquisar, setFiltro, filtro, modalProps, setModalProps
    } = useVeloeRotasPage();

    return (
        <StyledReportPage className="shadow rounded-md py-0.5">
            <div className="py-5">
                <h2 className="px-5 mb-4 text-lg font-semibold">Consulta de Custo de Rota</h2>
                <hr />
            </div>

            <div className="flex gap-x-3 px-3 -mt-2 -mb-3 items-end">
                <div>
                    <CodeLabel className="mb-1" htmlFor="inputProcesso" value="Processo:" />
                    <TextInput
                        id="inputProcesso"
                        type="text"
                        sizing={"sm"}
                        placeholder="Número do Processo"
                        onChange={(e) => setFiltro({ ...filtro, processingNumber: e.currentTarget.value })}
                    />
                </div>

                <Button
                    id="buttonGerarRelatorio"
                    size={'sm'}
                    disabled={loading}
                    onClick={handlePesquisar}
                    color={'light'}>

                    {loading && <div className={(loading ?? false) ? "mr-3 text-white" : "text-white"}>
                        <Spinner size="sm" light={true} />
                    </div>}

                    {!loading && <span><i className="text-sm" /> Pesquisar</span>}
                    {loading && <span>Pesquisando...</span>}
                </Button>

                <Button
                    id="buttonRecarga"
                    size={'sm'}
                    onClick={() => setModalProps({ ...modalProps, show: true, state: FormStateType.add })}
                    color={'dark'}>
                    <span>Calcular Rota</span>
                </Button>
            </div>

            <CondensedCodeDataGrid
                columns={columns}
                datasource={dataSource}
                header={{ filter: false }}
                readonly={true}
                pagination={{
                    limit: 500,
                    page: 1,
                    pageCount: 1,
                    recordCount: 0
                }}
                hoverable={true}
                striped={true} />

            {modalProps.show && <VeloeCalculoRotaModalPage {...modalProps} />}
        </StyledReportPage>
    );
}